import { render, staticRenderFns } from "./SelecaoAssinatura.vue?vue&type=template&id=614c95f8&scoped=true"
import script from "./SelecaoAssinatura.vue?vue&type=script&lang=js"
export * from "./SelecaoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./SelecaoAssinatura.vue?vue&type=style&index=0&id=614c95f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c95f8",
  null
  
)

export default component.exports